import { render, staticRenderFns } from "./BoxIconButton.vue?vue&type=template&id=abfd90ea&scoped=true"
import script from "./BoxIconButton.vue?vue&type=script&lang=js"
export * from "./BoxIconButton.vue?vue&type=script&lang=js"
import style0 from "./BoxIconButton.vue?vue&type=style&index=0&id=abfd90ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfd90ea",
  null
  
)

export default component.exports